import { getObjectValue } from "../../modules/screens/chatscreen/utils";

export const getChatCustomer = (state) => {
  return state.chatReducer.customer;
};
export const getChatOpenList = (state) => state.chatReducer.openList;
export const getChatAssignList = (state) => state.chatReducer.assignList;
export const getChatDynamic = (state, key) => {
  if (key.includes(".")) {
    return getObjectValue(state.chatReducer, key);
  }
  return state.chatReducer[key];
};

export const getCurrentChats = (state) => {
 return (
    state.chatReducer.messageList[
      state.chatReducer.selectedAssignedList.identifier
    ] || []
  );
};
export const getAgentStatus = (state) =>
  state.chatReducer.profile.status || "offline";
export const getLoadingStatus = (state) => {
 const selectedAssignedList = state.chatReducer.selectedAssignedList;
  return (
    selectedAssignedList &&
    selectedAssignedList.hasOwnProperty("loading") &&
    selectedAssignedList.loading
  );
};
export const getImageLoading = (state, id) => {
  if (!id) return;
  const messageList =
    state.chatReducer.messageList[
      state.chatReducer.selectedAssignedList.identifier
    ];
  let loading = null;
  for (let i = messageList.length - 1; i >= 0; i--) {
    if (messageList[i].id === id) {
      loading = messageList[i].lmessageListoading;
      break;
    }
  }
  return loading;
};

export const typingIndicatorCus = (state) =>
  state.chatReducer.typingIndicatorCus;

export const getTypingStatus = (state, id) =>
  state.chatReducer.typingIndicatorCus[id] || false;

export const getAgentTypingStatus = (state, id) => 
  state.chatReducer.typingAssistCus[id] || false;

// export const getChatAgentAssist = (state, id) =>
//   state.chatReducer.chatAgentAssist[id] || [];

export const getChatAgentAssist = (state) => state.chatReducer.chatAgentAssist;

export const getLoadingAgentAssistStatus = (state) => state.chatReducer.loadingAssistMsg;

export const getDisposeScreen = (state) => state.chatReducer.disposeScreen;

export const getActiveTab = (state) => state.chatReducer.activeTab;

export const getActiveTabRight = (state) => state.chatReducer.activeTabRight;

export const getUniqueTeamIds = (state) => state.chatReducer.uniqueTeamIds;

// export const getChatAgentAssist = (state, identifier) => {
//   if (!identifier) return [];

//   // Filter the chatAgentAssist array to find data that matches the identifier
//   return state.chatReducer.chatAgentAssist.filter(item => item.identifier === identifier);
// };



// WEBPACK FOOTER //
// src/store/selector/chat.selector.js